module.exports = __webpack_public_path__ + "2677779f662f82b0bf169d8651d29f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/team/Leadership_Curtis_0.jpg
// module id = 568
// module chunks = 0